import React from "react";
import { styled } from "@mui/material";

const StyledIconWithTitle = styled("div")`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  .irq-nav-wrapper {
    ${({ customStyles }) => customStyles};
  }
`;

export const IconWithTitle = ({ icon, title, customStyles }) => {
  return (
    <StyledIconWithTitle
      className="styled-icon-with-title"
      customStyles={customStyles}
    >
      {icon}
      {title}
    </StyledIconWithTitle>
  );
};
